/* VT Search Suggestion — VyomTara (assets/vt-search-suggestion.js) */
(function () {
  'use strict';

  var instances = [];
  var warned = {};

  var ICON_SEARCH = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" aria-hidden="true"><circle cx="11" cy="11" r="7"/><path d="m20 20-3.6-3.6"/></svg>';
  var ICON_ARROW = '<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"/><path d="M8 7h9v9"/></svg>';

  function esc(str) {
    return String(str == null ? '' : str).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function decode(str) {
    var t = document.createElement('textarea');
    t.innerHTML = str || '';
    return t.value;
  }

  function sizedImg(url, w) {
    if (!url) return '';
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  function safeClosest(node, selector) {
    if (!selector || !node || !node.closest) return null;
    try {
      return node.closest(selector);
    } catch (err) {
      if (!warned[selector]) {
        warned[selector] = true;
        console.warn('[VT Search] Invalid selector in theme settings:', selector);
      }
      return null;
    }
  }

  function groupDigits(n, decimals, thousands, decimal) {
    var parts = n.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousands);
    return parts.length > 1 ? parts[0] + decimal + parts[1] : parts[0];
  }

  function VtSearch(el) {
    var d = el.dataset;
    this.el = el;
    this.id = el.id;
    this.panel = el.querySelector('.vts__panel');
    this.form = el.querySelector('.vts__form');
    this.input = el.querySelector('.vts__input');
    this.clearBtn = el.querySelector('[data-vts-clear]');
    this.defaultView = el.querySelector('[data-vts-default]');
    this.resultsView = el.querySelector('[data-vts-results]');

    this.triggers = (d.triggers || '').trim();
    this.focusTriggers = (d.focusTriggers || '').trim();
    this.terms = (d.terms || '').split(',').map(function (t) { return t.trim(); }).filter(Boolean);
    this.prefix = d.prefix || '';
    this.rotateMs = parseInt(d.rotate, 10) || 3000;
    this.live = d.live === 'true';
    this.liveLimit = Math.min(parseInt(d.liveLimit, 10) || 8, 10);
    this.showQueries = d.showQueries === 'true';
    this.showCollections = d.showCollections === 'true';
    this.showCompare = d.showCompare === 'true';
    this.labels = {
      products: d.labelProducts || 'Products',
      viewAll: d.labelViewAll || 'View all',
      noResults: d.labelNoResults || 'No results found for',
      suggestions: d.labelSuggestions || 'Suggestions',
      collections: d.labelCollections || 'Collections'
    };
    this.moneyFormat = decode(d.moneyFormat) || '{{amount}}';
    this.root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    this.designMode = d.designMode === 'true';

    this.cache = {};
    this.timer = null;
    this.fetchCtrl = null;
    this.rotIdx = 0;
    this.rotTimer = null;
    this.isOpen = false;
    this.listeners = new AbortController();
    this.moved = false;

    // Move to <body> so sticky headers / transforms can't clip the fixed overlay
    if (!this.designMode && el.parentNode !== document.body) {
      document.body.appendChild(el);
      this.moved = true;
    }

    this.bind();
    this.setPlaceholder(false);

    if (this.designMode && d.previewOpen === 'true') this.open('', true);
  }

  VtSearch.prototype.bind = function () {
    var self = this;
    var opts = { capture: true, signal: this.listeners.signal };

    // Intercept clicks on the theme's search icon(s) before the old popup handles them
    window.addEventListener('click', function (e) {
      if (!self.triggers) return;
      var t = safeClosest(e.target, self.triggers);
      if (!t || self.el.contains(t)) return;
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      self.open();
    }, opts);

    // Optional: visible header search inputs
    if (this.focusTriggers) {
      document.addEventListener('focusin', function (e) {
        var t = safeClosest(e.target, self.focusTriggers);
        if (!t || self.el.contains(t)) return;
        var val = t.value || '';
        t.blur();
        self.open(val);
      }, opts);
    }

    document.addEventListener('keydown', function (e) {
      if (!self.isOpen) return;
      if (e.key === 'Escape') {
        e.preventDefault();
        self.close();
      } else if (e.key === 'Tab') {
        self.trapFocus(e);
      }
    }, { signal: this.listeners.signal });

    this.el.addEventListener('click', function (e) {
      if (e.target.closest('[data-vts-close]')) {
        e.preventDefault();
        self.close();
      }
    });

    this.input.addEventListener('input', function () { self.onInput(); });

    this.clearBtn.addEventListener('click', function () {
      self.input.value = '';
      self.onInput();
      self.input.focus();
    });

    this.form.addEventListener('submit', function (e) {
      if (!self.input.value.trim()) e.preventDefault();
    });
  };

  VtSearch.prototype.open = function (prefill, noFocus) {
    if (this.isOpen) return;
    instances.forEach(function (i) { if (i !== this && i.isOpen) i.close(); }, this);
    this.isOpen = true;
    this.lastFocus = document.activeElement;
    this.el.classList.add('is-open');
    this.el.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('vts-lock');

    if (prefill) {
      this.input.value = prefill;
      this.onInput();
    }

    var self = this;
    if (!noFocus) {
      setTimeout(function () {
        try { self.input.focus({ preventScroll: true }); } catch (err) { self.input.focus(); }
      }, 60);
    }
    this.startRotate();
  };

  VtSearch.prototype.close = function () {
    if (!this.isOpen) return;
    this.isOpen = false;
    this.el.classList.remove('is-open');
    this.el.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('vts-lock');
    this.stopRotate();
    if (this.lastFocus && this.lastFocus.focus && document.contains(this.lastFocus)) {
      try { this.lastFocus.focus({ preventScroll: true }); } catch (err) { /* ignore */ }
    }
  };

  /* Rotating placeholder */
  VtSearch.prototype.placeholderText = function () {
    var term = this.terms[this.rotIdx];
    if (term) return this.prefix ? this.prefix + ' \u201C' + term + '\u201D' : term;
    return this.prefix || 'Search';
  };

  VtSearch.prototype.setPlaceholder = function (animate) {
    var self = this;
    var txt = this.placeholderText();
    if (animate && !this.input.value) {
      this.input.classList.add('is-swapping');
      setTimeout(function () {
        self.input.setAttribute('placeholder', txt);
        self.input.classList.remove('is-swapping');
      }, 180);
    } else {
      this.input.setAttribute('placeholder', txt);
    }
  };

  VtSearch.prototype.startRotate = function () {
    var self = this;
    this.stopRotate();
    this.setPlaceholder(false);
    if (this.terms.length < 2) return;
    this.rotTimer = setInterval(function () {
      if (self.input.value) return;
      self.rotIdx = (self.rotIdx + 1) % self.terms.length;
      self.setPlaceholder(true);
    }, this.rotateMs);
  };

  VtSearch.prototype.stopRotate = function () {
    if (this.rotTimer) clearInterval(this.rotTimer);
    this.rotTimer = null;
  };

  /* Typing */
  VtSearch.prototype.onInput = function () {
    var self = this;
    var q = this.input.value.trim();
    this.clearBtn.hidden = !this.input.value;
    clearTimeout(this.timer);

    if (!q || !this.live) {
      this.showDefault();
      return;
    }
    this.timer = setTimeout(function () { self.fetchResults(q); }, 220);
  };

  VtSearch.prototype.showDefault = function () {
    if (this.fetchCtrl) this.fetchCtrl.abort();
    this.el.classList.remove('is-loading');
    if (this.defaultView) this.defaultView.hidden = false;
    this.resultsView.hidden = true;
    this.resultsView.innerHTML = '';
  };

  VtSearch.prototype.fetchResults = function (q) {
    var self = this;
    if (this.cache[q]) {
      this.render(q, this.cache[q]);
      return;
    }
    if (this.fetchCtrl) this.fetchCtrl.abort();
    this.fetchCtrl = new AbortController();
    this.el.classList.add('is-loading');

    var types = ['product'];
    if (this.showCollections) types.push('collection');
    if (this.showQueries) types.push('query');

    var url = this.root + 'search/suggest.json?q=' + encodeURIComponent(q) +
      '&resources[type]=' + types.join(',') +
      '&resources[limit]=' + this.liveLimit +
      '&resources[options][unavailable_products]=last';

    fetch(url, { signal: this.fetchCtrl.signal, headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (data) {
        var res = (data && data.resources && data.resources.results) || {};
        self.cache[q] = res;
        if (self.input.value.trim() === q) self.render(q, res);
      })
      .catch(function (err) {
        if (err.name !== 'AbortError') console.warn('[VT Search]', err);
      })
      .then(function () {
        self.el.classList.remove('is-loading');
      });
  };

  VtSearch.prototype.money = function (val) {
    var n = parseFloat(val);
    if (isNaN(n)) return '';
    var fmt = this.moneyFormat;
    var match = fmt.match(/\{\{\s*(\w+)\s*\}\}/);
    var key = match ? match[1] : 'amount';
    var v;
    switch (key) {
      case 'amount_no_decimals': v = groupDigits(n, 0, ',', '.'); break;
      case 'amount_with_comma_separator': v = groupDigits(n, 2, '.', ','); break;
      case 'amount_no_decimals_with_comma_separator': v = groupDigits(n, 0, '.', ','); break;
      case 'amount_with_apostrophe_separator': v = groupDigits(n, 2, "'", '.'); break;
      case 'amount_with_space_separator': v = groupDigits(n, 2, ' ', ','); break;
      default: v = groupDigits(n, 2, ',', '.');
    }
    return esc(fmt.replace(/\{\{\s*\w+\s*\}\}/, v));
  };

  VtSearch.prototype.card = function (p) {
    var img = (p.featured_image && p.featured_image.url) || p.image || '';
    var alt = (p.featured_image && p.featured_image.alt) || p.title;
    var price = parseFloat(p.price);
    var compare = parseFloat(p.compare_at_price_max);
    var priceHtml = '';
    if (this.showCompare && compare > price) priceHtml += '<s class="vts-card__compare">' + this.money(compare) + '</s>';
    priceHtml += '<span class="vts-card__sale">' + this.money(price) + '</span>';

    return '<a class="vts-card" href="' + esc(p.url) + '">' +
      '<div class="vts-card__media">' +
        (img ? '<img src="' + esc(sizedImg(img, 500)) + '" srcset="' + esc(sizedImg(img, 300)) + ' 300w, ' + esc(sizedImg(img, 500)) + ' 500w, ' + esc(sizedImg(img, 700)) + ' 700w" sizes="(min-width: 990px) 20vw, 45vw" alt="' + esc(alt) + '" loading="lazy">' : '') +
      '</div>' +
      '<p class="vts-card__title">' + esc(p.title) + '</p>' +
      '<div class="vts-card__price">' + priceHtml + '</div>' +
    '</a>';
  };

  VtSearch.prototype.render = function (q, res) {
    var self = this;
    var products = res.products || [];
    var collections = this.showCollections ? (res.collections || []) : [];
    var queries = this.showQueries ? (res.queries || []) : [];
    var formId = this.form.id;
    var html;

    if (!products.length && !collections.length && !queries.length) {
      html = '<div class="vts__empty"><p>' + esc(this.labels.noResults) + ' \u201C' + esc(q) + '\u201D</p></div>';
    } else {
      var side = '';
      if (queries.length) {
        side += '<div class="vts__group"><p class="vts__heading">' + esc(this.labels.suggestions) + '</p><ul class="vts__list">' +
          queries.map(function (x) {
            return '<li><a href="' + esc(x.url) + '">' + ICON_SEARCH + '<span>' + esc(x.text) + '</span></a></li>';
          }).join('') + '</ul></div>';
      }
      if (collections.length) {
        side += '<div class="vts__group"><p class="vts__heading">' + esc(this.labels.collections) + '</p><ul class="vts__list">' +
          collections.map(function (c) {
            return '<li><a href="' + esc(c.url) + '">' + ICON_ARROW + '<span>' + esc(c.title) + '</span></a></li>';
          }).join('') + '</ul></div>';
      }

      var main = '';
      if (products.length) {
        main = '<div class="vts__row-head"><p class="vts__heading">' + esc(this.labels.products) + '</p>' +
          '<button type="submit" form="' + esc(formId) + '" class="vts__shopall">' + esc(this.labels.viewAll) + '</button></div>' +
          '<div class="vts__grid">' + products.map(function (p) { return self.card(p); }).join('') + '</div>';
      }

      html = '<div class="vts__results-grid' + (side && main ? '' : ' vts__results-grid--full') + '">' +
        (side ? '<div class="vts__side">' + side + '</div>' : '') +
        (main ? '<div class="vts__main">' + main + '</div>' : '') +
      '</div>';
    }

    this.resultsView.innerHTML = html;
    if (this.defaultView) this.defaultView.hidden = true;
    this.resultsView.hidden = false;
  };

  VtSearch.prototype.trapFocus = function (e) {
    var nodes = this.panel.querySelectorAll('a[href], button:not([disabled]), input:not([type="hidden"])');
    var focusable = Array.prototype.filter.call(nodes, function (n) {
      return !n.hidden && n.offsetParent !== null;
    });
    if (!focusable.length) return;
    var first = focusable[0];
    var last = focusable[focusable.length - 1];
    if (!this.panel.contains(document.activeElement)) {
      e.preventDefault();
      first.focus();
    } else if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  };

  VtSearch.prototype.destroy = function () {
    this.close();
    this.stopRotate();
    this.listeners.abort();
    if (this.fetchCtrl) this.fetchCtrl.abort();
    if (this.moved && this.el.parentNode) this.el.parentNode.removeChild(this.el);
  };

  /* Init */
  function init(scope) {
    (scope || document).querySelectorAll('[data-vt-search]').forEach(function (el) {
      if (el.__vts) return;
      el.__vts = new VtSearch(el);
      instances.push(el.__vts);
    });
  }

  function bySection(sectionId) {
    for (var i = 0; i < instances.length; i++) {
      if (instances[i].id === 'VtSearch-' + sectionId) return instances[i];
    }
    return null;
  }

  window.VtSearchOverlay = {
    open: function (q) { var i = instances[instances.length - 1]; if (i) i.open(q); },
    close: function () { instances.forEach(function (i) { i.close(); }); }
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  // Theme editor support
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var inst = bySection(e.detail.sectionId);
    if (!inst) return;
    inst.destroy();
    instances = instances.filter(function (i) { return i !== inst; });
  });
  document.addEventListener('shopify:section:select', function (e) {
    var inst = bySection(e.detail.sectionId);
    if (inst) inst.open('', true);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var inst = bySection(e.detail.sectionId);
    if (inst) inst.open('', true);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var inst = bySection(e.detail.sectionId);
    if (inst && inst.el.dataset.previewOpen !== 'true') inst.close();
  });
})();